import { Container, Hollow, MovingBlock, Solid } from "./styles";
import hollowFork from "../../../assets/icons/hollow-fork.svg";
import fork from "../../../assets/icons/fork.svg";
import hollowWhite from "../../../assets/icons/hollow-white.svg";
import forkWhite from "../../../assets/icons/fork-white.svg";
import { Reg1 } from "../../Fonts";
import React from "react";
export var LoadingPage = function (_a) {
    var text = _a.text, duration = _a.duration, reverse = _a.reverse;
    return (React.createElement(Container, { reverse: reverse },
        React.createElement("div", { style: { position: "relative" } },
            React.createElement(MovingBlock, { duration: duration, reverse: reverse }),
            reverse ? React.createElement(Hollow, { src: hollowWhite }) : React.createElement(Hollow, { src: hollowFork }),
            reverse ? React.createElement(Solid, { src: forkWhite }) : React.createElement(Solid, { src: fork })),
        React.createElement(Reg1, { style: { color: reverse ? "#ffffff" : "#fe1933" } }, text)));
};
//# sourceMappingURL=index.js.map